// Tiny inline SVG sparkline — no chart library needed
export default function Sparkline({ data = [], width = 110, height = 28, color = "#0A192F" }) {
    if (!data || data.length === 0) return null;
    const max = Math.max(...data, 1);
    const min = Math.min(...data, 0);
    const range = max - min || 1;
    const step = data.length > 1 ? width / (data.length - 1) : width;
    const points = data.map((v, i) => {
        const x = i * step;
        const y = height - ((v - min) / range) * height;
        return `${x.toFixed(1)},${y.toFixed(1)}`;
    }).join(" ");
    const last = data[data.length - 1];
    const lastX = (data.length - 1) * step;
    const lastY = height - ((last - min) / range) * height;
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="overflow-visible">
            <polyline points={points} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx={lastX} cy={lastY} r="2.5" fill={color} />
        </svg>
    );
}
